import { useMutation } from '@tanstack/react-query'

import type { MutationFeedback } from '@/integrations/tanstack-query/types'

import type { MoveEnvelopeToVaultParams } from './move-envelope-to-vault'
import {
  MOVE_ENVELOPE_QUERY_KEYS,
  moveEnvelopeToVault,
} from './move-envelope-to-vault'

export const useMoveEnvelopeToVault = (feedback?: MutationFeedback) => {
  return useMutation({
    mutationFn: (params: MoveEnvelopeToVaultParams) =>
      moveEnvelopeToVault(params),
    meta: {
      invalidatesQuery: MOVE_ENVELOPE_QUERY_KEYS,
      ...feedback,
    },
  })
}
